"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AppLayout;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const AppFooter_1 = __importDefault(require("@/pages/AppFooter"));
const AppHeader_1 = __importDefault(require("@/pages/AppHeader"));
const AppPageInfo_1 = __importDefault(require("@/pages/AppPageInfo"));
const MenuLocationListener_1 = require("@/components/menu/MenuLocationListener");
function AppLayout() {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "container mx-auto bg-[var(--page-background)]", children: [(0, jsx_runtime_1.jsx)(MenuLocationListener_1.MenuLocationListener, {}), (0, jsx_runtime_1.jsx)(AppHeader_1.default, {}), (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}), (0, jsx_runtime_1.jsx)(AppPageInfo_1.default, {}), (0, jsx_runtime_1.jsx)(AppFooter_1.default, {})] }));
}
